module.exports = "//d2t2kh5dwcod2h.cloudfront.net/8d87c6ba0c9d4b1b42066aca310da561e3ca510e/images/photo-couple-wide.png";